export enum SkanVersion {
  "v2.0" = "2.0",
  "v2.1" = "2.1",
  "v2.2" = "2.2",
  "v3.0" = "3.0",
  "v4.0" = "4.0",
}
